<!-- item.route -->
<a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="item-link d-flex align-items-center" [ngClass]="item.classes" *ngIf="item.route && !item.externalUrl && !item.event" [routerLink]="[item.route]">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>

<!-- item.externalUrl -->
<a class="item-link d-flex align-items-center" [ngClass]="item.classes" *ngIf="item.route && item.externalUrl && !item.event" [href]="item.route + '?lang=' + transloco.getActiveLang()">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>

<!-- item.event -->
<span class="item-link d-flex align-items-center" [ngClass]="item.classes" *ngIf="item.event" (click)="onEvent(item)">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</span>

<ng-template #itemContent>
  <i class="icon {{ item.icon }}"></i><span [innerText]="item.name | transloco"></span>
</ng-template>
